import { ComponentConfig } from "@measured/puck"
import { commonStylesProps } from "../../../lib/commonCSSProps"
import { BikeRentalTableProp, RenderConfig } from "./RenderConfig"

export const BikeRentalTable: ComponentConfig<BikeRentalTableProp> = {
  label: "CaoCao | Bike Rental Table",
  //@ts-ignore
  fields: {
    columns: {
      label: "Columns",
      type: "array",
      arrayFields: {
        label: { label: "Label", type: "text" },
        align: {
          label: "Align",
          type: "select",
          options: [
            { label: "Left", value: "left" },
            { label: "Center", value: "center" },
            { label: "Right", value: "right" },
          ],
        },
        fontWeight: {
          label: "Font Weight",
          type: "select",
          options: [
            { label: "Thin", value: "100" },
            { label: "Extra Light", value: "200" },
            { label: "Light", value: "300" },
            { label: "Normal", value: "400" },
            { label: "Medium", value: "500" },
            { label: "Semi Bold", value: "600" },
            { label: "Bold", value: "700" },
            { label: "Extra Bold", value: "800" },
            { label: "Black", value: "900" },
          ],
        },
      },
    },
    rows: {
      label: "Rows",
      type: "array",
      arrayFields: {
        cells: {
          label: "Cells",
          type: "array",
          arrayFields: {
            value: { label: "Value", type: "text" },
          },
        },
      },
    },

    ...commonStylesProps,
  },
  defaultProps: {
    columns: [
      { label: "TYPES OF BIKE", align: "left", fontWeight: "400" },
      { label: "PRICE", align: "center", fontWeight: "600" },
      { label: "INCLUSION", align: "left", fontWeight: "600" },
    ],
    rows: [
      { cells: [{ value: "Mountain bikes" }, { value: "1,500,000" }, { value: "Helmet" }] },
      { cells: [{ value: "Mountain bikes" }, { value: "1,500,000" }, { value: "Helmet" }] },
      { cells: [{ value: "Mountain bikes" }, { value: "1,500,000" }, { value: "Helmet" }] },
      { cells: [{ value: "Mountain bikes" }, { value: "1,500,000" }, { value: "Helmet" }] },
      { cells: [{ value: "Mountain bikes" }, { value: "1,500,000" }, { value: "Helmet" }] },
    ],
    className: "",
  },

  ...RenderConfig,
}

export default BikeRentalTable
